var map = {
	"./fa-brands-400.eot": 2350,
	"./fa-brands-400.svg": 5038,
	"./fa-brands-400.ttf": 1396,
	"./fa-brands-400.woff": 8353,
	"./fa-brands-400.woff2": 4158,
	"./fa-regular-400.eot": 7698,
	"./fa-regular-400.svg": 1170,
	"./fa-regular-400.ttf": 9322,
	"./fa-regular-400.woff": 4967,
	"./fa-regular-400.woff2": 8939,
	"./fa-solid-900.eot": 881,
	"./fa-solid-900.svg": 4266,
	"./fa-solid-900.ttf": 4769,
	"./fa-solid-900.woff": 5706,
	"./fa-solid-900.woff2": 7819
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5463;